const checklistDashboardUsers = [
  {
    id : "59e52a4a23febd1300d2519c",
    email : "abdias@vertix.com.mx"
  },
  {
    id : "59c92061623de112002cf29f",
    email : "berny@vertix.com.mx"
  },
  {
    id : "5bb21efaff948f130040db09",
    email : "contacto@vertix.com.mx"
  },
  {
    id : "5a57e3551d408e1500a43315",
    email : "ivan@vertix.com.mx"
  },
  {
    id : "59e61e39623de112002cf2d0",
    email : "liz@vertix.com.mx"
  }
];

const DOGFOODING_USERS = {
  "visitsDashboard": checklistDashboardUsers
}

export const DOGFOODING_PRODUCTS = {
  ChecklistDashboard: "visitsDashboard"
};

export function hasPermissions(product, userID){
  const validUsers = DOGFOODING_USERS[product];
  if(!validUsers) return false; 
  return !!validUsers.find(validUser => validUser.id === userID);
}